export const getSelectData=(data)=>{
  return data.map((item)=>{
    return {
      id: item.key,
      value: item.name,
    };
  });
};
export const getProvinceData=(data)=>{
  return data.map((item)=>{
    return {
      id: item.id,
      value: item.title,
    };
  });
};